export enum TipoPico{
    Carter = 0,
    Gatillo = 1
}